import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import styles from './ReloadNotice.module.css';

export const ReloadNotice = ({
  reload,
  automatic = false,
  dismissible = true,
}: {
  reload: () => void;
  automatic?: boolean;
  dismissible?: boolean;
}) => {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!automatic) {
      return;
    }
    const build =
      document.querySelector('meta[name="presentr-deploy-sha"]')?.getAttribute('content') ??
      'unknown';
    const key = `presentr-recovery:${build}`;
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      reload();
    }
  }, [automatic, reload]);
  if (automatic) {
    return (
      <main className={styles.recovery} role="status">
        Presentatie herstellen… Start casten opnieuw als dit scherm blijft staan.
      </main>
    );
  }
  if (dismissed) {
    return null;
  }
  return (
    <aside className={styles.notice} role="status">
      <RefreshCw className={styles.icon} size={20} aria-hidden="true" />
      <div>
        <strong>Update beschikbaar</strong>
        <p>Vernieuw na je presentatie of gesprek.</p>
        <button className={styles.reload} type="button" onClick={reload}>
          <RefreshCw size={15} aria-hidden="true" />
          PresentR vernieuwen
        </button>
      </div>
      {dismissible && (
        <button
          className={styles.close}
          type="button"
          aria-label="Update later uitvoeren"
          onClick={() => setDismissed(true)}
        >
          <X size={17} />
        </button>
      )}
    </aside>
  );
};
